import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const noticeDefaultVariants = {}
const noticeCompoundVariants = []

const noticeSlotNames = [
  [
    "root",
    "notice__root"
  ],
  [
    "contentWrapper",
    "notice__contentWrapper"
  ],
  [
    "content",
    "notice__content"
  ],
  [
    "icon",
    "notice__icon"
  ],
  [
    "text",
    "notice__text"
  ],
  [
    "title",
    "notice__title"
  ],
  [
    "message",
    "notice__message"
  ],
  [
    "actionWrapper",
    "notice__actionWrapper"
  ],
  [
    "confirmButton",
    "notice__confirmButton"
  ],
  [
    "closeButton",
    "notice__closeButton"
  ],
  [
    "closeButtonIcon",
    "notice__closeButtonIcon"
  ]
]
const noticeSlotFns = /* @__PURE__ */ noticeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, noticeDefaultVariants, getSlotCompoundVariant(noticeCompoundVariants, slotName))])

const noticeFn = memo((props = {}) => {
  return Object.fromEntries(noticeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const noticeVariantKeys = [
  "type",
  "status",
  "hasTitle"
]
const getVariantProps = (variants) => ({ ...noticeDefaultVariants, ...compact(variants) })

export const notice = /* @__PURE__ */ Object.assign(noticeFn, {
  __recipe__: false,
  __name__: 'notice',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: noticeVariantKeys,
  variantMap: {
  "type": [
    "default",
    "action",
    "inline"
  ],
  "status": [
    "error",
    "warning",
    "success",
    "info",
    "basic"
  ],
  "hasTitle": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, noticeVariantKeys)
  },
  getVariantProps
})